import { h, Component } from 'preact';

import { configure } from '../../../config';
import pageStyles from '../pageStyles';
import style from './style';

import { COMMON_CONFIGS, getCommonProps } from '../../../lib/page';
import { trackPageLoad } from '../../../lib/tracking';
import { Footer } from '../shared/desktop';

import { deviceVariance, isDeviceType, DEVICE_TYPE_GROUP_DESKTOP } from '@cube/blocks';
import Header from '@cube/header-widget';
import { Row, Section, ContainerFluid } from '@cube/layout';
import { trackingProvider, DIMENSION } from '@cube/track';

@trackingProvider({
	[DIMENSION.componentpath]: 'ErrorPage'
})
@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.error',
	clientDisplayName: 'clientDisplayName'
})
@deviceVariance()
export default class Error extends Component {

	componentDidMount() {
		trackPageLoad(this.context);
	}

	render({ pageConfig, device, clientDisplayName, ...props }) {

		return (
			<ContainerFluid class={pageStyles.fluidPageNoPadding}>
				<Header
					pageConfig={pageConfig}
				/>
				<Section>
					<Row class={pageStyles.singleWidgetRow}>
						<div class={style.fourOhFour}>
							<div class={style.message}>
								<div class={style.title}>
									{pageConfig.title}
								</div>
								<div class={style.subTitle}>
									{pageConfig.subTitle}
								</div>
							</div>
							{ pageConfig.button &&
								<div class={style.buttonWrapper}>
									<a class={style.button} href="/">
										{ pageConfig.button.replace('{{clientDisplayName}}', clientDisplayName) }
									</a>
								</div>
							}
						</div>
					</Row>
				</Section>
				{
					isDeviceType(device, DEVICE_TYPE_GROUP_DESKTOP) &&
					<Footer
						pageConfig={pageConfig}
						{...getCommonProps(props)}
					/>
				}
			</ContainerFluid>
		);
	}
}
